import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, getAmountWithCurrency } from '@pascal/pascal-core';
import { doBetStore } from '../../store/doBetStore';

export const WinPopup = observer(() => {
  const { win } = doBetStore;

  return win?.winAmount ? (
    <>
      <div className='winPopupWrapper winBackground'>
        <div className='winAmountHolder'>
          <span className='winAmount'>
            {getAmountWithCurrency({ amount: convertAmount(win?.winAmount) })}
          </span>
        </div>
      </div>
      {/* <div className="winPopupWrapper maxWinBackground">*/}
      {/*    <div className="winAmountHolder">*/}
      {/*<span className="maxWinTxt">*/}
      {/*  You have reached the max win amount of the game, please make a cashout.*/}
      {/*</span>*/}
      {/*        <span className="winAmount">*/}
      {/*  $5000*/}
      {/*</span>*/}
      {/*    </div>*/}
      {/*</div>*/}
    </>
  ) : null;
});
